import React from 'react';
import { useEmbedFilters } from './EmbedWrapper';
import { useAnnouncementsData } from '../../hooks/useEmbedData';
import { AnnouncementsWidget } from '../AnnouncementsWidget';

const EmbedAnnouncements: React.FC = () => {
  const filters = useEmbedFilters();
  const { data, isLoading, error } = useAnnouncementsData(filters);

  if (error) {
    return <div className="text-red-600 text-center py-4">Error: {error}</div>;
  }

  return <AnnouncementsWidget announcements={data} isLoading={isLoading} />;
};

export default EmbedAnnouncements;
